import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { GestionesService } from '../gestiones.service';
import { environment as env } from 'environments/environments';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { Usuario, Usuarios } from 'app/models/usuarios.model';
import { UsuariosService } from '../../usuarios/usuarios.service';
import { CrearTareaModel, FormTareaInterface } from 'app/models/crear-tarea.model';
import { UtilsService } from 'app/modules/utils-service';
import { UserService } from 'app/core/user/user.service';
import { UsurioLogueado } from 'app/core/user/user.types';
import { MatRadioModule } from '@angular/material/radio';
import { CONSTANTS } from 'app/core/constants';

@Component({
    selector: 'form-gestion',
    templateUrl: 'form-gestion.component.html',
    imports:[
        CommonModule,
        MatFormField,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatRadioModule
    ]
})

export class FormGestionComponent implements OnInit {
    formControl: UntypedFormGroup
    prioridades: Tipologia[]
    origenList: Tipologia[]
    usuariosList: Usuario[]
    seccionesLis: Tipologia[]
    idGestion:number
    infoUsuarioLogueado: UsurioLogueado
    clasificaciones:Tipologia[]

    tipologyIdClasificaciones:number= CONSTANTS.TIPOLOGIA_ID_CLASIFICACIONES
    tipologiaIdOrigenTareaVA: number = CONSTANTS.ID_ORIGEN_TAREA_VENTANILLA_AGIL


    constructor(
        public dialogRef: MatDialogRef<FormGestionComponent>,
        private _formBuilder: UntypedFormBuilder,
        private _gestionesService: GestionesService,
        private usuariosService: UsuariosService,
        private UtilsService: UtilsService,
        private _userService: UserService
    ) {
        this.getPrioridades()
        this. getOrigenGestion()
        this.getUsurios()
        this.getSecciones()
        this.getClasificacion()

        this.idGestion= env.TIPOLOGIA_ID_GESTIONES
     }

    ngOnInit() {

        this.infoUsuarioLogueado= this._userService.usuarioLogueadoValues
        this.formControl= this._formBuilder.group({
            tipoTarea:[this.idGestion, Validators.required],
            nombreGestion:['', Validators.required],
            descripcion:['', Validators.required],
            usuarioAsignado: ['', Validators.required],
            prioridad: ['', Validators.required],
            origen: ['', Validators.required],
            seccion:['', Validators.required],
            documento:[''],
            solicitante: ['', Validators.required],
            clasificacion: ['', Validators.required]
        })

    }

    getPrioridades(){
        this._gestionesService.getTipologias(env.TIPOLOGIA_PADRE_ID_PRIORIDAD)
            .then((response: TipologiasInterface)=>{
                this.prioridades= response[0].tipologias
                this.formControl.patchValue({ prioridad: this.prioridades[2].tipologiaId });
            })
    }

    getOrigenGestion(){
        this._gestionesService.getTipologias(env.TIPOLOGIA_PADRE_ID_ORIGEN_TAREA)
            .then((response: TipologiasInterface)=>{
                this.origenList= response[0].tipologias
                this.formControl.patchValue({ origen: this.origenList[1].tipologiaId });
            })
    }

    getUsurios(){
            this.usuariosService.getUsuarios()
            .then((usuarios: Usuarios) => {
                this.usuariosList = usuarios.data
                const usuariosEncontrado = this.usuariosList.find(user=> user.usuarioId=== parseInt(this.infoUsuarioLogueado.user_id))
                if (usuariosEncontrado ){
                    this.formControl.patchValue({ usuarioAsignado: usuariosEncontrado.usuarioId });
                }
                
            });
    }
    
    getSecciones(){
        this._gestionesService.getTipologias(env.TIPOLOGIA_PADRE_ID_SECCION)
            .then((response: TipologiasInterface)=>{
                this.seccionesLis= response[0].tipologias
                const seccionEncontrada = this.seccionesLis.find(seccion=> seccion.tipologiaId=== parseInt(this.infoUsuarioLogueado.seccion_id))
                if (seccionEncontrada ){
                    this.formControl.patchValue({ usuarioAsignado: seccionEncontrada.tipologiaId });
                }
            })
    }

    postGestion(){
        const formValues:FormTareaInterface = this.formControl.value; 
        const formGestion = new CrearTareaModel(formValues);
        this._gestionesService.postGestion(formGestion)
            .then((response)=>{
                this.UtilsService.openSuccessSnakBar('Gestión creada correctamente')
                this._gestionesService.getTotalesGestiones()
                this.getAllTareas()
                this.dialogRef.close(false);
            })
    }

    async getClasificacion() {
        try {
            const response1 = await this._gestionesService.getTipologias(env.TIPOLOGIA_CLASIFICACION_FORMULARIOS);
            const response2 = await this._gestionesService.getTipologias(this.tipologyIdClasificaciones);

            this.clasificaciones = [
            ...response1[0].tipologias,
            ...response2[0].tipologias
            ];
        } catch (error) {
            console.error('Error al obtener clasificaciones:', error);
        }
    }



    //actualiza la tabla de gestiones al crear una nueva gestion
    getAllTareas() {
        const seccion_uuid = this.UtilsService.seccion_uuid_value;
        const esGenerales = this.UtilsService.esRutaGenerales_value;
        const usuarioAsignado = parseInt(this._userService.usuarioLogueadoValues.user_id);
    
        let params: any = {};
    
        if (seccion_uuid) {
            params.seccion = seccion_uuid;
        } else if (!esGenerales) {
            params.usuarioAsignado = usuarioAsignado;
        }
    
        this._gestionesService.getAllTasks(params);
    }

    onClose() {
        this.dialogRef.close(false);
    }

}